import script from "./BenMingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BenMingTable.vue?vue&type=script&setup=true&lang=js"

import "./BenMingTable.vue?vue&type=style&index=0&id=33fda20d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33fda20d"]])

export default __exports__